import React, { Component } from 'react';
import Headers from '../Headers';
// import Tables from '../Tables';
// import SendoutTable from '../Sending-Out/sendOutTable';
import CCTable from './ccTable';
import axios from 'axios';
import url from '../../config/url';
import DisplayError from '../../DisplayError';
import Singleton from '../../sock';
import { ToastContainer } from 'react-toastr';
import DownloadCsvs from './downloadCsv';

const fileHeaders = [
    {
        label: 'Membership #', key: 'number'
    },
    {
        label: 'Name', key: 'memberName'
    },
    {
        label: 'Member Branch', key: 'memberBranch'
    },
    {
        label: 'Closure Date', key: 'closure'
    },
    {
        label: 'Status', key: 'status'
    }
];

const theaders = ['Membership #', 'Name', 'Member Branch', 'Closure Date', 'Status']
const mHeaders = ['number', 'memberName', 'memberBranch', 'closure', 'status'];//edit it according to json data
var cardNo = [];
class ClosedCards extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cardNo: '',
            startListening: false,
            tData: {},
            errorVisible: false,
            errorDesc: null,
            resetTableBody:false,
            update:false,
            start:true,
            colorToDisplay:'',
            shouldUpdate:false
        }
        this.handleStart = this.handleStart.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleStop = this.handleStop.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
    }

    handleClear(){
        cardNo = [];
        this.input.value = 0;
        this.setState({ tData: {},  resetTableBody: true });
    }


    handleStart() {
        this.setState({ startListening: true, stop:true});

    }

    handleStop(){
        this.setState({ update:true, startListening: false})
    }

    handleUpdate(){
        var uniqueCards = cardNo.unique();
        var memberBranchId= sessionStorage.getItem('bId');
        var branchId = sessionStorage.getItem('at');
        var cardsCsv = uniqueCards.join(",");
        console.log(memberBranchId+" "+branchId+" "+cardsCsv);

        var dataToPost = {
            "memberCardsCsv":cardsCsv,
            "memberBranchId":memberBranchId,
            "branchId":branchId
        }

        axios.post(url+"updateClosedCards", dataToPost).then(response =>{
            console.log(response);
            var successObject = response.data.successObject;
            console.log(successObject);
            if (response.data.status && successObject.length > 0) {
                var tableData = [];
                for (let i = 0; i < successObject.length; i++) {
                    //append status if color change is required
                    tableData.push({
                        number: successObject[i].memberCard,
                        message: successObject[i].statusMsg
                    });
                }
                this.setState(prevState => ({
                    tData: tableData,
                    resetTableBody: !prevState.resetTableBody,
                    shouldUpdate:true
                }));

            }
            else {

                this.setState({ errorVisible: true, errorDesc: response.data.errorDescription })

            }
        }).catch(err => {
            console.log(err);
        })

    }

    componentWillMount() {

        this.sock = Singleton.getInstance();
    }

    componentDidMount() {
        this.sock.onmessage = msg => {
            if (typeof (msg.data) === 'string') {
                this.fetchCode(msg.data);
            }
            else {
                FileReader.prototype.that = this;
                var reader = new FileReader();
                reader.onload = function () {
                    console.log(reader.result)
                    reader.__proto__.that.fetchCode(reader.result)
                }
                reader.readAsText(msg.data)

            }
        };
        this.sock.onerror = (err) => {
            console.log(err);
            this.refs.container.error("Could not connect to ThingMagic. Please check your connection and refresh");
            
        }
        // this.sock.onerror = (err) => {
        //     console.log(err);
        //     this.setState({
        //         errorVisible: true,
        //         errorDesc: "Could not connect to kiosk. Please check your connection and refresh"
        //     })
        // }

    }
    componentWillUnmount() {
        cardNo = [];
        console.log('sortbook unmount connection will be closed now');
        Singleton.closeSocket(this.sock);
    }


    fetchCode(value) {
        // console.log(value);
        if (this.state.startListening) {
            if (cardNo.includes(value)) {
                // console.log(cardNo);
                return;
            }
            else {
                cardNo.push(value);
                var branchId = sessionStorage.getItem('at');
                axios.get(url + 'getMemberCardDetailsKiosk?cardNumber=' + value+'&branchId='+branchId).then(res => {
                    var { tData } = this.state;
                    if (res.data['status']) {

                        var card_data = res.data['successObject'][0]
                        tData.number = card_data['membershipNo'];
                        tData.memberName = card_data['memberName']
                        tData.memberBranch = card_data['memberBranchID'] + "-" + card_data['memberBranchName'];
                        tData.closure = "";
                        tData.status = card_data['statusMsg'];
                        sessionStorage.setItem('bId',card_data['memberBranchID']);
                        console.log(card_data);
                        var colorToDisplay = '';
                        if(card_data['status']){
                            colorToDisplay = "green";
                        }else{
                            colorToDisplay = "red";
                        }
                        this.setState({ tData: tData, colorToDisplay:colorToDisplay });
                    
                    } else {
                        // cardNo.pop(value);
                        this.refs.container.error(res.data.errorDescription)
                        // this.setState({ errorVisible: true, errorDesc: res.data.errorDescription })
                    }
                }).catch(err => {
                    console.log(err);
                    cardNo.pop(value);
                    console.log(cardNo);
                    this.refs.container.error("Something went wrong")

                    // this.setState({ errorVisible: true, errorDesc: "Something went wrong" })
                })
            }
        }

    }


    render() {
        return (
            <div>
                <Headers hname="Closed Cards" />
                <ToastContainer 
                    ref = "container"    
                    className="toast-top-right"
                />
                <DisplayError
                    errorVisible={this.state.errorVisible}
                    errorDesc={this.state.errorDesc}
                />
                <div className="row" style={{ marginTop: 30 }}>
                    <div className="col-lg-4 pull-center">
                        <div className="btngroup btnclass btn-toolbar">
                            {this.state.start ? <button style={{ marginRight: 10 }} className="btn btn-md" onClick={this.handleStart} type="button">Start</button>:''}
                            {this.state.stop ? <button style={{ marginRight: 10 }} className="btn btn-md" onClick={this.handleStop} type="button">Stop</button>:''}
                            <button style={{ marginRight: 10 }} className="btn btn-md" onClick={this.handleClear}>Clear</button>
                            {this.state.update ?<button style={{ marginRight: 10 }} className="btn btn-md" onClick={this.handleUpdate}>Process</button>:''}
                        </div>
                    </div>
                    <div className="col-lg-2 pull-right">
                        <label htmlFor="count">Count:</label>
                        <input type="text" style={{ margin: 5, width: 50 }} ref={(input) => this.input = input} name="count" id="count" readOnly />
                    </div>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-4 pull-right">
                        <DownloadCsvs
                                headers={fileHeaders}
                                onclickCb={this.onclickCb}
                                tableId = {"myTable"}
                                keys = {mHeaders}
                                filename = {`ClosedCards_${new Date().getDate()}-${new Date().getMonth()}.csv`}
                            />
                    </div>
                </div>
                <CCTable
                    body={this.state.tData}
                    myStyle={{ marginTop: 30 }}
                    headers={theaders}
                    mHeaders={mHeaders}
                    displayCount={this.input}
                    shouldUpdate={this.state.shouldUpdate}
                    resetTable={this.state.resetTableBody}
                    colorToDisplay = {this.state.colorToDisplay}
                />

            </div>
        )
    }
}

export default ClosedCards;


                {/* <Tables
                    body={this.state.tData}
                    myStyle={{ marginTop: 30 }}
                    mHeaders={mHeaders}
                    displayCount={this.input}
                    headers={theaders} 
                    resetTable = {this.state.reset}
                    /> */}


// WEBPACK FOOTER //
// ./src/Components/Receive-Closed-Cards/ClosedCards.js